<template>
<div class="kt-portlet kt-portlet--tabs kt-portlet-opportunity" >
  <slot name="header" />

  <div v-bind="$attrs">
    <slot />
  </div>
</div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'TabbedPortletOpportunity'
}
</script>

<style>
.kt-portlet--tabs{
  padding: 0px 20px;
}
</style>
